// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14gBo","title":"Header_title__1JbLv","side":"Header_side__3mRkP"};